import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4a8f310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-message relative animation-duration-200 animation-ease-in-out" }
const _hoisted_2 = ["src"]

import { ref } from "vue";
import { get } from "@vueuse/core";
import VideoDialog from "../../dialog/video.vue";

type IContentMessage = {
  id: number;
  content: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'video',
  props: {
    id: null,
    content: null
  },
  setup(__props: any) {



const boxVideoDialog = ref<HTMLElement>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        role: "presentation",
        alt: "image",
        src: __props.content
      }, null, 8, _hoisted_2),
      _createElementVNode("div", {
        class: "block absolute pi pi-play btn-play z-1 cursor-pointer border-circle animation-ease-in-out animation-duration-200",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(get)(boxVideoDialog.value)?.onPlay()))
      })
    ]),
    _createVNode(VideoDialog, {
      ref_key: "boxVideoDialog",
      ref: boxVideoDialog,
      id: __props.id
    }, null, 8, ["id"])
  ], 64))
}
}

})